import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Country } from '@viewbid/ts-angular-client';

// The generated client carries no schema patterns, so the contract's postal code rule is copied here.
const POSTAL_CODE_RULES: Readonly<Record<string, RegExp>> = {
    [Country.Ca]: /^[ABCEGHJ-NPRSTVXY]\d[A-Z]\d[A-Z]\d$/,
    [Country.Us]: /^\d{5}(-\d{4})?$/,
};

export function postalCodeFormatHint(country: unknown): string {
    return country === Country.Us
        ? 'Enter a ZIP such as 12345 or 12345-6789'
        : 'Enter a postal code such as A1A1A1';
}

export function postalCodeValidator(
    countryField: string = 'country',
): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: unknown = control.value;
        if (typeof value !== 'string' || value === '') {
            return null;
        }
        const country: unknown = control.parent?.get(countryField)?.value;
        const rule: RegExp =
            POSTAL_CODE_RULES[String(country)] ?? POSTAL_CODE_RULES[Country.Ca];
        return rule.test(value) ? null : { postalCode: true };
    };
}
